/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import moment from "moment";
import { Form as FormUi, Container, TextArea, Button, Input, Grid, Header, Segment, Dropdown, Icon, Search, ButtonGroup, Divider, } from "semantic-ui-react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { min, isEmpty } from "lodash";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import {
  createShipmentDispatcher,
  deleteAllOrderDispatcher,
} from "../../redux/actions/shipmentAction";
import MandatoryMark from "../common/mandatorymark";
import { DateData } from "../dynamicComponent/datepick";
import SearchDropdown from "../bookingRequestComponent/searchDropdown";
import ModalCreateRoute from "../createShipmentComponent/modalCreateRoute";

const ShipmentDetails = ({
  values,
  vehicleTypeMaster,
  setFieldValue,
  touched,
  errors,
  handleSubmit,
  shipment,
  shipmentEdit,
  routeCodes,
  routeNames,
  mode,
  isSubmitting,
  deleteAllOrderDispatcher,
  t,
  props
}) => {
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
  }, [editMode])


  return (
    <React.Fragment>

      <Segment className="mt-110">
        <div>
          <Header as='h4' className="heading-01" content='Shipment Detail' textAlign='left' />
          {/* <h2 className="heading-01">Shipment details</h2> */}
          <div className="header-btn">
            <Button size="mini" color="green" icon inverted labelPosition='left' onClick={(e) => { e.preventDefault(); e.stopPropagation(); setEditMode(!editMode) }}>
              <Icon name='edit' />
              Edit
            </Button>
            {editMode ?
            <Button.Group size="mini">
              <Button>Cancel</Button>
              <Button.Or />
              <Button positive>Save</Button>
            </Button.Group>
            :''}
          </div></div>
        <Divider clearing />
        <Formiker>

          <FormUi.Group>
            <FormUi.Field>

              <Grid container columns={4} doubling>

                <Grid.Column>
                  <label>Movement Type: </label>
                </Grid.Column>
                <Grid.Column>
                  {/* <select fluid  placeholder='Movement' control="Dropdown" /> */}
                  {editMode ?
                    <Dropdown
                      name="movement_type"
                      clearable
                      search
                      style={{ width: "100%" }}
                      selection
                      placeholder={""}
                      options={[
                        { key: "3", text: "Primary", value: "primary" },
                        { key: "2", text: "Import", value: "import" },
                        { key: "4", text: "Export", value: "export" },
                      ]}

                    />
                    :
                    'primary'}
                </Grid.Column>
                <Grid.Column></Grid.Column>
                <Grid.Column> </Grid.Column>
                <Grid.Column>
                  <label>Estimated Clearance End Date: </label>
                </Grid.Column>
                <Grid.Column>
                  {editMode ?
                    <Input fluid Field placeholder='21-10-2021' />
                    :
                    '21-10-2021'}
                </Grid.Column>
                <Grid.Column>
                  <label>Boarding Number: </label>
                </Grid.Column>
                <Grid.Column>
                  {editMode ?
                    <Input fluid Field placeholder='BNI2252' />
                    :
                    'BNI2252'}
                </Grid.Column>
                <Grid.Column>
                  <label>Route</label>
                </Grid.Column>
                <Grid.Column>
                  {editMode ?
                    <div>
                      <SearchDropdown
                        disabled={mode == "view" ? true : false}
                        setField={(name, value) => {
                          setRouteAddressState(value.raw ? value.raw : "");
                          // setFieldValue("vehicle_number", value.raw ? value.raw.vehicleNumber : value)
                          setFieldValue(
                            "route",
                            value.raw ? value.raw.routeCode : ""
                          );
                          setFieldValue(
                            "deliveries[0].requested_delivery_date",
                            //values.requested_pickup_date
                            value.raw ? moment(values.deliveries[0].requested_pickup_date).add(value.raw.budgetedRouteTat, 'hours').format('YYYY-MM-DD HH:mm') : ""
                          );
                        }}
                        placeholder={values.route_placeholder}
                        masterRoute="routeMaster"
                        masterRouteKey="routeMasterId"
                        masterRouteName="routeName"
                        fieldName="route"
                      />

                      <div>
                        <ModalCreateRoute />
                      </div>
                    </div>
                    :
                    ''}
                  {/* {editMode ?
                  <Input fluid Field placeholder='Globex Corporation' />
                  :
                  'Globex Corporation'} */}
                </Grid.Column>
                <Grid.Column>
                  <label>Import Declaration Number: </label>
                </Grid.Column>
                <Grid.Column>
                  {editMode ?
                    <Input fluid Field placeholder='BHGF35655' />
                    :
                    'BHGF35655'}
                </Grid.Column>
                <Grid.Column>
                  <label>Source: </label>
                </Grid.Column>
                <Grid.Column>
                  {editMode ?
                    <Input fluid Field placeholder='Globex Corporation' />
                    :
                    'Globex Corporation'}
                </Grid.Column>
                <Grid.Column>
                  <label>Destination: </label>
                </Grid.Column>
                <Grid.Column>
                  {editMode ?
                    <Input fluid Field placeholder='Massive Dynamic' />
                    :
                    'Massive Dynamic'}
                </Grid.Column>
                <Grid.Column>
                  <label>Service Type: </label>
                </Grid.Column>
                <Grid.Column>
                  {editMode ?
                    <Input fluid Field placeholder='FTL' />
                    :
                    'FTL'}
                </Grid.Column>
                <Grid.Column>
                  <label>Load Type: </label>
                </Grid.Column>

                <Grid.Column>
                  {editMode ?
                    <Input fluid Field placeholder='Ambient' />
                    :
                    'Ambient'}
                </Grid.Column>

              </Grid>
            </FormUi.Field>
          </FormUi.Group>

        </Formiker>

      </Segment>
    </React.Fragment>
  );
};

const FormikShipment = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
  }),
  // setFieldValue("required_on", moment().format("DD/MM/yyyy hh:mm"));
  mapPropsToValues: (props) => (
    {
      //movement_type: (props.shipmentEdit ? props.shipmentEdit.movement_type : localStorage.getItem("customerNumber") != 1122 ? "primary" : "import"),
    }),
  handleSubmit(values, { setFieldValue, setSubmitting, props }) {

  },
})(ShipmentDetails);

const mapStateToProps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToProps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher,
  deleteAllOrderDispatcher,
})(translate("create_shipment")(FormikShipment));
